import { ArrowBack, ArrowForward, Close } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import BlockIcon from '@mui/icons-material/Block';
import { variants } from '../../../variants/variants';
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter';
import AttachAvatar from '../../../common/AttachAvatar';
import { useUpdateAdminNominationStatusMutation } from '../shabashApiSlice';
import { useMediaQuery } from '@mui/system';
import { Avatar } from '@mui/material';
import AttachmentGallery from '../../../common/Utility/AttachmentGallery ';
import defaultimg from '../../../common/default.png';
import toast from 'react-hot-toast';

const OverviewDialog = ({ handleCloseDialog, open, selectedNomination }) => {
  const [rejectionReason, setRejectionReason] = useState('');
  const [openRejectionDialog, setOpenRejectionDialog] = useState(false);
  const [updateAdminNominationStatus] = useUpdateAdminNominationStatusMutation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const scrollContainerRef = useRef(null);
  console.log('selectedNomination', selectedNomination);
  const handleUpdateAdminStatus = async (nominationId, type, adminRejectionReason) => {
    try {
      if ((type === 'reject' && adminRejectionReason.trim() !== '') || type === 'approve') {
        const response = await updateAdminNominationStatus({ nominationId, adminRejectionReason }).unwrap();
        setOpenRejectionDialog(false);
        handleCloseDialog();
      } else {
        toast.error('Please Fill Rejection Reason');
      }
    } catch (error) {
      console.log(error, 'ERROR');
    }
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            backgroundColor: '#0A4FAC',
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: variants.fontSize.HEADING,
            fontWeight: '600',
          }}
        >
          Nomination Details
          <IconButton onClick={handleCloseDialog} size="small" sx={{ color: 'white' }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2, objectFit: '' }}>
          {selectedNomination && (
            <>
              <DialogContentText fontSize={variants.fontSize.SUB_HEADING}>
                <strong>Awarded by:</strong>{' '}
                <Typography component={'span'}>{capitalizeFirstLetter(selectedNomination.nominatedBy)}</Typography>
              </DialogContentText>
              <DialogContentText fontSize={variants.fontSize.SUB_HEADING}>
                <strong>Employee Name:</strong>{' '}
                <Typography component={'span'}>{capitalizeFirstLetter(selectedNomination.employeeName)}</Typography>
              </DialogContentText>

              <DialogContentText fontSize={variants.fontSize.SUB_HEADING}>
                <strong>Nomination Reason:</strong> {selectedNomination.nominationReason}
              </DialogContentText>
              <Box mt={2}>
                <Typography variant="body1">
                  <strong>Attachment:</strong>
                </Typography>
                {selectedNomination.attachment.length > 0 ? (
                  <Box mt={2} display="flex" alignItems="center">
                    <Box
                      ref={scrollContainerRef}
                      sx={{
                        display: 'flex',
                        overflowX: 'auto',
                        scrollBehavior: 'smooth',
                        width: '100%',
                        '&::-webkit-scrollbar': {
                          display: 'none',
                        },
                      }}
                    >
                      <AttachmentGallery
                        attachments={selectedNomination.attachment}
                        isDetailScreen={true}
                        defaultimg={defaultimg}
                      />
                    </Box>
                  </Box>
                ) : (
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'gray',
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: isMobile ? '12px' : '16px',
                    }}
                  >
                    <BlockIcon sx={{ marginRight: 0.5 }} /> No attachment provided
                  </Typography>
                )}
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            disabled={selectedNomination?.status !== 'Pending'}
            onClick={() => handleUpdateAdminStatus(selectedNomination._id, 'approve', rejectionReason)}
            color="primary"
          >
            Approve
          </Button>
          <Button
            disabled={selectedNomination?.status !== 'Pending'}
            onClick={() => setOpenRejectionDialog(true)}
            color="primary"
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openRejectionDialog} onClose={() => setOpenRejectionDialog(false)}>
        <DialogTitle>Reject Request</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Rejection Reason"
            type="text"
            fullWidth
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            required
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRejectionDialog(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => handleUpdateAdminStatus(selectedNomination._id, 'reject', rejectionReason)}
            color="primary"
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OverviewDialog;
